import React from 'react';
import {
    Route as ReactRouterRoute,
    Routes as ReactRouterRoutes,
    useNavigate,
} from 'react-router-dom';
import { Route } from '../../../../types';
import { DPage } from '../../../dum';
import { navigateToClientPage } from '../../../../services';
import { AccountsPage } from '../../management/accounts/accounts/accounts-page';
import { AccountPage } from '../../management/accounts/account/account-page';

// Clientes (Ventas domain). Reuses the account list + account view components in
// read-only, client-scoped mode. The is_client scoping is enforced server-side
// for Ventas users, so this is purely the UI surface — see the Clientes plan.
export function ClientsHomePage() {
    const navigate = useNavigate();

    const clientsPages: Route[] = [
        {
            name: 'ClientsPage',
            path: '/',
            component: (
                <AccountsPage
                    isClient
                    viewOnly
                    title={'Clientes'}
                    storageKeyPrefix={'ClientsPage'}
                    navigateToItem={(accountId) =>
                        navigateToClientPage({ navigate, accountId })
                    }
                />
            ),
            title: 'Clientes',
            navbar: false,
        },
        {
            name: 'ClientPage',
            path: '/:accountId',
            component: <AccountPage viewOnly />,
            title: 'Cliente',
            navbar: false,
        },
    ];

    return (
        <DPage>
            <ReactRouterRoutes>
                {clientsPages.map((page, index) => {
                    return (
                        <ReactRouterRoute
                            path={page.path}
                            element={page.component}
                            key={index}
                        />
                    );
                })}
            </ReactRouterRoutes>
        </DPage>
    );
}
